import React from 'react';
import { NavLink } from 'react-router-dom';
import { Avatar } from '../ui/Avatar';
import { chefById } from '../../data/chefs';
import { counterpartById } from '../../data/counterparts';
import { relativeTime } from '../../utils/format';
import { useLocale } from '../../contexts/LocaleContext';
import { cn } from '../../utils/cn';
import type { Thread } from '../../types/chat';
export function ThreadList({
  threads,
  role,
  basePath,
  onNavigate
}: {
  threads: Thread[];
  role: 'chef' | 'customer';
  basePath: string;
  onNavigate?: () => void;
}) {
  const {
    locale,
    readMessage
  } = useLocale();
  return <ul className="divide-y divide-hairline" data-id="element-266" data-mp="37aqmyaeeespw">
      {threads.map(thread => {
      const other = role === 'chef' ? counterpartById(thread.customerId) : chefById(thread.chefId);
      const last = thread.messages[thread.messages.length - 1];
      const unread = role === 'chef' ? thread.unreadForChef : thread.unreadForCustomer;
      const preview = last ? last.kind === 'quote' ? 'Sent a custom quote' : readMessage(last).text : 'No messages yet';
      return <li key={thread.id} data-id="element-267" data-mp="2qcudy2mhzudz">
            <NavLink to={`${basePath}/${thread.id}`} onClick={onNavigate} className={({
          isActive
        }) => cn('flex gap-3 px-4 py-3.5 transition-colors duration-150 ease-out', isActive ? 'bg-primary-soft' : 'hover:bg-oat')} data-id="element-268" data-mp="353l3t54j4jeg">
              <Avatar name={other?.name ?? 'Guest'} src={(other as {
            photo?: string;
          })?.photo} size="sm" data-id="element-269" data-mp="27hxbavb72l87" />
              <span className="min-w-0 flex-1" data-id="element-270" data-mp="2ldr7qeus7i4f">
                <span className="flex items-baseline justify-between gap-2" data-id="element-271" data-mp="2he0iwgotfc2j">
                  <span className={cn('truncate text-sm', unread ? 'font-semibold text-ink' : 'font-medium text-ink')} data-id="element-272" data-mp="pcym7733e5h">
                    {other?.name ?? 'Guest'}
                  </span>
                  <span className="shrink-0 text-[11px] text-ink-3" data-id="element-273" data-mp="2pii3tj3dzy0u">{relativeTime(thread.lastAt, locale)}</span>
                </span>
                <span className="mt-0.5 block truncate text-[12px] text-ink-3" data-id="element-274" data-mp="2ugjmi2wwhvbs">{thread.subject}</span>
                <span className={cn('mt-1 block truncate text-[13px]', unread ? 'text-ink' : 'text-ink-2')} data-id="element-275" data-mp="2zhqwm8min6lm">{preview}</span>
              </span>
              {!!unread && <span className="tnum mt-1 h-5 shrink-0 rounded-full bg-action px-1.5 text-[11px] font-semibold leading-5 text-on-action" data-id="element-276" data-mp="26sjxp8j5gezu">
                  {unread}
                </span>}
            </NavLink>
          </li>;
    })}
    </ul>;
}